// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureBadges_container__2ws_i","iconsContainer":"FeatureBadges_iconsContainer__1VdbY","bottomHex":"FeatureBadges_bottomHex__22OTC"};